import React from 'react'
import { useI18n } from '@/i18n'

export function SkipToContentLink() {
    const i18n = useI18n()

    function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault()
        const target = document.getElementById('main-content')
        if (target) {
            target.focus()
            target.scrollIntoView()
        } else {

            console.warn('Skip-to-content: #main-content anchor not found on this page')
            document.body.focus()
        }
    }

    return (
        <a
            href="#main-content"
            data-testid="skip-to-content-link"
            onClick={handleClick}
            className={[
                'sr-only',
                'focus:not-sr-only',
                'focus:fixed',
                'focus:top-2',
                'focus:left-2',
                'focus:z-[9999]',
                'focus:px-4',
                'focus:py-2',
                'focus:bg-background',
                'focus:text-foreground',
                'focus:border',
                'focus:border-ring',
                'focus:rounded',
                'focus:outline-none',
                'focus:ring-2',
                'focus:ring-ring',
            ].join(' ')}
        >
            {i18n.accessibility.skipToContent}
        </a>
    )
}
